export default "__VITE_ASSET__Bh$f6970__"